import { SPELL_ID } from '../ids/spell-id'
import { SpellMap } from 'web/data/models'
import { MODIFIER_ID } from '../ids/modifier-id'

export const PALADIN_SPELLS: SpellMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Holy
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [SPELL_ID.PALADIN.HOLY.AM]: {
        id: SPELL_ID.PALADIN.HOLY.AM,
        talentId: undefined,

        name: "Aura Mastery",
        shortName: "AM",

        cooldown: 180,
        affectedByModifierIds: [],

        game_id: 31821,
        icon_name: "spell_holy_auramastery",
    },

    [SPELL_ID.PALADIN.HOLY.WINGS]: {
        id: SPELL_ID.PALADIN.HOLY.WINGS,
        talentId: undefined,

        name: "Avenging Wrath",
        shortName: "Wings",

        cooldown: 120,
        affectedByModifierIds: [MODIFIER_ID.ESSENCE_VOP],

        game_id: 31884,
        icon_name: "spell_holy_avenginewrath",
    },
}
